import React from 'react'

function PrivacyPolicy() {
  return (
    <div className="bg-background-secondary-color rounded-lg p-6 font-popins lg:m-[100px] mt-5">
      <h2 className="text-3xl font-extrabold text-btn-color mb-10">Privacy Policy</h2>
      <div className="space-y-8 max-w-4xl">
        <p className="text-sm text-white mt-4">
          At <span className="text-btn-color-500 font-bold">FinzAid.com</span>, your privacy is important to us. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website or engage with our services.
        </p>

        <h3 className="text-lg font-semibold text-btn-color">Information We Collect</h3>
        <p className="text-sm text-white mt-4">
          We may collect personal information such as your name, email address, phone number, and other details when you sign up for our services, subscribe to our newsletter, or fill out forms on our website. We also collect non-personal information such as your IP address, browser type, and how you interact with our website for analytics purposes.
        </p>

        <h3 className="text-lg font-semibold text-btn-color">How We Use Your Information</h3>
        <p className="text-sm text-white mt-4">
          The information we collect is used to provide and improve our services, enhance your user experience, and keep you informed of relevant updates. We may use your data for:
        </p>
        <ul className="list-disc list-inside text-sm text-white mt-4">
          <li>Personalizing your experience on <span className="text-btn-color-500 font-bold">FinzAid.com</span></li>
          <li>Sending you newsletters or promotional offers</li>
          <li>Responding to your inquiries and providing customer support</li>
          <li>Improving website functionality and user experience</li>
        </ul>

        <h3 className="text-lg font-semibold text-btn-color">Sharing of Information</h3>
        <p className="text-sm text-white mt-4">
          We do not sell or share your personal information with third parties, except as necessary to provide our services or when required by law. For example, we may share data with service providers who assist with email campaigns, analytics, and payment processing, under strict confidentiality agreements.
        </p>

        <h3 className="text-lg font-semibold text-btn-color">Security</h3>
        <p className="text-sm text-white mt-4">
          The security of your data is a top priority. We implement strong security measures to protect your information from unauthorized access, disclosure, or alteration. All sensitive data transmitted through <span className="text-btn-color-500 font-bold">FinzAid.com</span> is encrypted using industry-standard protocols.
        </p>

        <h3 className="text-lg font-semibold text-btn-color">Your Rights</h3>
        <p className="text-sm text-white mt-4">
          You have the right to access, update, or delete your personal information at any time. If you wish to opt out of marketing communications or request data deletion, please contact us directly at <span className="text-btn-color-500 font-bold">info@FinzAid.com</span>.
        </p>

        <h3 className="text-lg font-semibold text-btn-color">Changes to This Privacy Policy</h3>
        <p className="text-sm text-white mt-4">
          We may update this Privacy Policy from time to time. Any changes will be posted on this page, and we encourage you to review it periodically to stay informed about how we are protecting your data.
        </p>

        <p className="text-sm text-white mt-4">
          If you have any questions or concerns about this Privacy Policy, please feel free to contact us at <span className="text-btn-color-500 font-bold">info@FinzAid.com</span>.
        </p>
      </div>
    </div>
  )
}

export default PrivacyPolicy;
